import React, { useState } from 'react';

import { useGetImagesListQuery } from 'features/imagesStore';

import { ImageStoreTable } from './components/ImageStoreTable';

const defaultPageSize = 30;

const initParams = {
  page: 1,
  pageSize: defaultPageSize,
};

export const ImageStoreTablePage = () => {
  const [params, setParams] = useState(initParams);

  const {
    items,
    count,
    isLoading
  } = useGetImagesListQuery(params, {
    selectFromResult: ({ data, isFetching }) => ({
      items: data?.items ?? [],
      count: data?.count ?? 0,
      isLoading: isFetching
    })
  });

  const handlePaginationChange = (page: number, pageSize: number) => {
    setParams((prev) => ({
      ...prev,
      page,
      pageSize,
    }));
  };

  return (
    <div>
      <ImageStoreTable
        items={items}
        itemsTotal={count}
        currentPage={params.page}
        defaultPageSize={defaultPageSize}
        onPageChange={handlePaginationChange}
        isLoading={isLoading}
      />
    </div>
  );
};
